import socketIOClient from 'socket.io-client'
import Config from 'config'
import createEmitters from 'api/emitters'
import initListeners from 'api/listeners'

let emittersObject = null
let socket = null

const create = (type, { uuid, username, password }) => {
    if (socket === null) {
        socket = socketIOClient.connect(Config.api.url)
        initListeners(type, socket)

        emittersObject = createEmitters(type, socket)

        let authData = { type }
        if (type === 'player') {
            authData = { ...authData, playerUuid: uuid }
        } else if (uuid) {
            if (type === 'superadmin') {
                authData = { ...authData, superadminUuid: uuid }
            } else {
                authData = { ...authData, adminUuid: uuid }
            }
        } else {
            authData = { ...authData, username, password }
        }
        emittersObject.auth.authenticate(authData)
    }
}

const exists = () => socket !== null

const emitters = () => emittersObject

const socketInstance = () => socket

const disconnect = () => {
    if (socket) {
        socket.disconnect()
        socket = null
    }
}

export default {
    socketInstance,
    emitters,
    create,
    exists,
    disconnect
}



// WEBPACK FOOTER //
// src/api/index.js